<template>
  <v-card>
    <v-expansion-panels multiple>
      <v-expansion-panel v-test="{ panel: '' }">
        <v-expansion-panel-header>
          <div id="info">
            <v-icon>
              info
            </v-icon>
            {{ $t("Общая информация") }}
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-row class="text-left px-4">
            <text-view
                :display="lotTemplate.lotDescription"
                multiline
                :label="$t('Предмет договора (наименование)')" />
            <text-view
                :display="$t(LOT_TYPE_ENUM[lotTemplate.lotType])"
                multiline
                md="6"
                :label="$t('Тип торговой процедуры')" />
            <text-view
                :display="$t(PREMIUM_TYPE_ENUM[lotTemplate.premiumType])"
                multiline
                md="6"
                :label="$t('Способ расчета цены')" />
            <text-view
                v-if="lotTemplate.premiumType === PREMIUM_TYPES.FIX"
                :display="lotTemplate.currency"
                multiline
                md="6"
                :label="$t('Валюта Договора')" />
            <text-view
                :display="
                  lotTemplate.organizer
                    ? lotTemplate.organizer.organizationName
                    : null
                "
                multiline
                md="6"
                :label="$t('Организатор')" />
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel v-test="{ panel: '' }">
        <v-expansion-panel-header>
          <div id="contact_mail">
            <v-icon>
              contact_mail
            </v-icon>
            {{ $t("Контактная информация") }}
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-row class="text-left px-4">
            <text-view
                icon="person"
                :display="lotTemplate.contactPerson"
                multiline
                md="6"
                :label="$t('Контактное лицо')" />
            <text-view
                icon="alternate_email"
                :display="lotTemplate.contactEmail"
                multiline
                md="6"
                :label="$t('Электронный адрес')" />
            <text-view
                icon="settings_phone"
                :display="lotTemplate.contactPhone"
                multiline
                md="6"
                :label="$t('Контактный телефон')" />
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel v-test="{ panel: '' }">
        <v-expansion-panel-header>
          <div id="client">
            <v-icon>
              contact_mail
            </v-icon>
            {{ $t("Клиент") }}
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-row class="text-left px-4">
            <text-view
                :display="lotTemplate.clientOrganizationInn"
                multiline
                md="6"
                :label="$t('ИНН организации Клиента')" />
            <text-view
                :display="lotTemplate.clientOrganizationFullName"
                multiline
                md="6"
                :label="$t('Полное наименование организации Клиента')" />
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel v-if="positions">
        <v-expansion-panel-header>
          <div id="storage">
            <v-icon>
              storage
            </v-icon>
            {{ $t("Состав торговой процедуры") }}
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager class="py-2">
          <v-card>
            <slot name="positions" />
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
  import TextView from '@/components/reused/ui/TextView.vue'
  import {
    DICTIONARY_TYPES,
    LOT_STATUSES,
    PREMIUM_TYPES
  } from '@/constants/business'
  import {
    LOT_TYPE_ENUM,
    LOT_STATUS_TYPE_ENUM,
    TRADE_RESULT_TYPE_FULL_VOLUME_ENUM,
    PREMIUM_TYPE_ENUM
  } from '@/constants/enums'

  export default {
    components: {
      TextView
    },
    props: {
      lotTemplate: {
        type: Object,
        required: true
      },
      positions: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        LOT_TYPE_ENUM,
        DICTIONARY_TYPES,
        LOT_STATUS_TYPE_ENUM,
        TRADE_RESULT_TYPE_FULL_VOLUME_ENUM,
        LOT_STATUSES,
        PREMIUM_TYPE_ENUM,
        PREMIUM_TYPES
      }
    },
    computed: {}
  }
</script>
